const FEATURES = {
  create_survey_limit: {
    summaryLine: 'Number of surveys',
    tooltip: {
      title: 'Number of surveys',
      description: 'Send as many surveys, polls, and quizzes as you need.'
    }
  },
  analyze_response_limit: {
    summaryLine: 'Number of responses',
    tooltip: {
      title: 'Number of responses',
      description:
        "With a free plan, you can collect more than 100 responses, but you can only view the first 100 responses. Upgrade at any time to access additional responses. Our {select_equivalent_name} Monthly plan includes 1000 responses per monthly billing cycle across all your surveys with a <span class='notranslate'>{overage_cost}</span> charge per additional response. All annual plans include an unlimited number of responses."
    }
  },
  analyze_response_limit_monthly_plans: {
    summaryLine: 'Number of responses',
    tooltip: {
      title: 'Number of responses',
      description:
        "With a free plan, you can collect more than 100 responses, but you can only view the first 100 responses. Upgrade at any time to access additional responses. Our {select_equivalent_name} Monthly plan includes 1,000 responses and our {gold_equivalent_name} Monthly plan includes 2,000 responses per monthly billing cycle across all your surveys. There is a <span class='notranslate'>{overage_cost}</span> charge per additional response. All annual plans include unlimited responses."
    }
  },
  crosstab: {
    summaryLine: 'Crosstabs',
    tooltip: {
      title: 'Crosstabs',
      description:
        'Run advanced comparisons across multiple questions, uncover statistically significant differences, and share your crosstab report with anyone.'
    }
  },
  collector_create_limit: {
    summaryLine: 'Number of collectors',
    tooltip: {
      title: 'Number of collectors',
      description:
        'Collectors are ways you can send your survey to respondents. Our collector types include weblinks, email, embedding on your website, and more.'
    }
  },
  mobile_apps_ios_android: {
    summaryLine: 'Mobile apps for iOS and Android',
    tooltip: {
      title: 'Mobile apps for iOS and Android',
      description:
        'Access the essential features you need to create a survey, collect responses, and analyze results with the free SurveyMonkey app for iOS and Android.'
    }
  },
  user_accounts: {
    summaryLine: 'User accounts included',
    tooltip: {
      title: 'User accounts included',
      description:
        'This is the total number of user accounts included with your plan. Plans with more than 1 user have access to all team collaboration tools. '
    }
  },
  add_users: {
    summaryLine: 'Additional user accounts',
    tooltip: {
      title: 'Additional user accounts',
      description:
        'Team plans start at 3 users, and allow you to invite more people to your SurveyMonkey team for an additional fee. <a href="/mp/collaboration/?ut_source=pricing-details" target="_blank">Learn More &raquo;</a>'
    }
  },
  advanced_permissions: {
    summaryLine: 'Advanced permissions',
    tooltip: {
      title: 'Advanced permissions',
      description:
        'Collaborate with fine control over who can view and edit your survey projects.'
    }
  },
  build_surveys_together: {
    summaryLine: 'Build surveys together',
    tooltip: {
      title: 'Build surveys together',
      description:
        'Let people on your team view, edit, or comment on your surveys.'
    }
  },
  analyze_results_together: {
    summaryLine: 'Analyze results together',
    tooltip: {
      title: 'Analyze results together',
      description: 'Give your team access to survey results and export tools.'
    }
  },
  custom_templates: {
    summaryLine: 'Shared templates',
    tooltip: {
      title: 'Shared templates',
      description:
        'Turn your custom surveys into standard templates that everyone in your team can use.'
    }
  },
  team_themes: {
    summaryLine: 'Shared themes',
    tooltip: {
      title: 'Shared themes',
      description:
        "Share custom themes with your team to stay consistent with your brand's look and feel."
    }
  },
  shared_group_library: {
    summaryLine: 'Shared library',
    tooltip: {
      title: 'Shared library',
      description:
        'Get access to shared images, documents, themes, and templates that everyone in your team can use.'
    }
  },
  international_email_support: {
    summaryLine: '{lang} email support',
    tooltip: {
      title: '{lang} email support',
      description:
        'We offer {lang} email support in Central European Time (CET).'
    }
  },
  team_ownership: {
    summaryLine: 'Team ownership',
    tooltip: {
      title: 'Team ownership',
      description:
        'Choose whether you or your organization owns all the accounts within your team in SurveyMonkey.'
    }
  },
  add_additional_users: {
    summaryLine: 'Additional users',
    tooltip: {
      title: 'Additional users',
      description:
        'Team plans include 3 users. You can easily add or re-assign users at any time. Enterprise plans allow you to add as many users as  you need across your organization.'
    }
  },
  consolidated_billing: {
    summaryLine: 'Consolidated billing',
    tooltip: {
      title: 'Consolidated billing',
      description:
        'Receive a consolidated bill for your entire team in SurveyMonkey.'
    }
  },
  essential_question_types: {
    summaryLine: '13 essential question types',
    tooltip: {
      title: '13 essential question types',
      description:
        'Choose from 13 different formats for your survey questions, including multiple choice, text box, matrix, NPS, and A/B comparisons.'
    }
  },
  all_languages_supported: {
    summaryLine: 'All languages supported',
    tooltip: {
      title: 'All languages supported',
      description:
        'Create surveys in any language. You can write in unicode or multi-byte languages, and choose navigation buttons, help text, and error messages from 58 languages.'
    }
  },
  labeling_titles_numbering: {
    summaryLine: 'Labeling, titles & numbering',
    tooltip: {
      title: 'Labeling, titles & numbering',
      description:
        'Guide respondents through your surveys with labels, titles, and page numbers for any page in your surveys.'
    }
  },
  create_templates_enabled: {
    summaryLine: 'Expert, pre-written survey templates',
    tooltip: {
      title: 'Expert, pre-written survey templates',
      description:
        'Choose from over 180 survey templates in our Question Bank library. All templates are certified by our expert methodologists.'
    }
  },
  question_library: {
    summaryLine: 'Question Bank approved questions',
    tooltip: {
      title: 'Question Bank approved questions',
      description:
        'Rely on over 1800 pre-written survey questions (and 180+ survey templates), written by experts to make it easier to get great results.'
    }
  },
  create_skip_logic_enabled: {
    summaryLine: 'Question and page skip logic',
    tooltip: {
      title: 'Question and page skip logic',
      description:
        "Create custom paths through surveys that change based on a respondent's answers. Skip logic is also known as 'conditional branching' or 'branch logic'."
    }
  },
  matrix_of_dropdown_menus: {
    summaryLine: 'Matrix of dropdown menus',
    tooltip: {
      title: 'Matrix of dropdown menus',
      description:
        'Allow respondents to evaluate several items using the same set of measurements by choosing from a preset list of answer choices.'
    }
  },
  file_upload: {
    summaryLine: 'File upload',
    tooltip: {
      title: 'File upload',
      description:
        'Allow respondents to upload a file as part of their survey response. You can add up to 20 file upload questions per survey.'
    }
  },
  advanced_logic: {
    summaryLine: 'Advanced survey logic',
    tooltip: {
      title: 'Advanced survey logic',
      description:
        'Enhance your survey data with access to advanced branching, advanced piping, block randomization, quotas, and more. Use custom variables to track data about respondents by passing one or more values through a survey link and into your survey results.'
    }
  },
  create_randomization_enabled: {
    summaryLine: 'Question & page randomization',
    tooltip: {
      title: 'Question & page randomization',
      description:
        'Reduce answer bias by randomizing the order of the pages in a survey or the order of questions within a page.'
    }
  },
  a_b_testing: {
    summaryLine: 'A/B test question type',
    tooltip: {
      title: 'A/B test question type',
      description:
        'Conduct A/B tests and test for answer bias by randomly segmenting respondents to see different images or text.'
    }
  },
  create_quotas_enabled: {
    summaryLine: 'Response quotas',
    tooltip: {
      title: 'Response quotas',
      description:
        'Close your survey automatically when you get all the qualified responses you need.'
    }
  },
  multiple_block_rotation_enabled: {
    summaryLine: 'Block randomization',
    tooltip: {
      title: 'Block randomization',
      description:
        'Blocks are groups of pages, where each group contains related questions about a particular concept you want to test. You can use block randomization logic to rotate, flip, or randomize blocks to minimize order bias.'
    }
  },
  create_logo_enabled: {
    summaryLine: 'Add your logo',
    tooltip: {
      title: 'Add your logo',
      description:
        'Make your survey stand out. Add a custom image or logo, and personalize the work you send.'
    }
  },
  create_custom_theme_enabled: {
    summaryLine: 'Custom themes, colors & more',
    tooltip: {
      title: 'Custom themes, colors & more',
      description:
        'Create custom themes to change the look and feel of your survey. You can edit the colors of different survey elements and choose from several web fonts for your survey.'
    }
  },
  collector_friendly_url_enabled: {
    summaryLine: 'Custom SurveyMonkey URL',
    tooltip: {
      title: 'Custom SurveyMonkey URL',
      description:
        'Write customized survey URLs, for example: http://www.surveymonkey.com/s/your-survey'
    }
  },
  custom_html_email_invitations: {
    summaryLine: 'Custom HTML email invitations',
    tooltip: {
      title: 'Custom HTML email invitations',
      description:
        'Add custom designs, images, embed videos, or hyperlink text in your email messages used to send your survey.'
    }
  },
  create_piping_enabled: {
    summaryLine: 'Question & answer piping',
    tooltip: {
      title: 'Question & answer piping',
      description:
        "Take respondents' answers from a previous question to personalize questions on a later page in the survey."
    }
  },
  carry_forward: {
    summaryLine: 'Carry forward responses',
    tooltip: {
      title: 'Carry forward responses',
      description:
        "Use each respondent's previous answer choices in a related question that appears later in your survey. You can carry forward either a respondent's selected or unselected answer choices and choose to show all or some previously selected or unselected answers. Responses that are carried forward cannot be edited."
    }
  },
  collector_completion_url_enabled: {
    summaryLine: 'Survey completion redirect',
    tooltip: {
      title: 'Survey completion redirect',
      description:
        'For a customized experience, redirect survey respondents to your website once they complete your survey.'
    }
  },
  create_custom_variables_enabled: {
    summaryLine: 'Custom variables',
    tooltip: {
      title: 'Custom variables',
      description:
        'Use custom variables to track data about respondents by passing one or more values through a survey link and into your survey results.'
    }
  },
  collector_white_label_enabled: {
    summaryLine: 'White label surveys',
    tooltip: {
      title: 'White label surveys',
      description:
        'Completely customize and brand your surveys. Remove the SurveyMonkey footer from your surveys, change the domain of your survey link to research.net, and redirect survey respondents to your site upon survey completion.'
    }
  },
  analyze_shared_results_enabled: {
    summaryLine: 'Share survey data',
    tooltip: {
      title: 'Share survey data',
      description: 'Invite anyone to view data from your survey.'
    }
  },
  analyze_trends_enabled: {
    summaryLine: 'Data trends',
    tooltip: {
      title: 'Data trends',
      description:
        'View your results trended over time to spot changes when they happen.'
    }
  },
  filter_crosstab: {
    summaryLine: 'Filter and compare results',
    tooltip: {
      title: 'Filter and compare results',
      description:
        'Filter your results and compare how different groups answered the questions in your survey. Segment your data to uncover trends and correlations in your data.'
    }
  },
  word_cloud: {
    summaryLine: 'Word clouds',
    tooltip: {
      title: 'Word clouds',
      description:
        'Quickly spot trends and common themes in written answers. Words with lots of mentions appear bigger so you can get a quick understanding of what matters most to your respondents.'
    }
  },
  word_cloud_combine_hide: {
    summaryLine: 'Word clouds: Combine or hide words',
    tooltip: {
      title: 'Word clouds: Combine or hide words',
      description:
        'Get more control over the words that appear in your word cloud. Combine similar words, hide others, and choose the frequency of words to include.'
    }
  },
  text_analysis: {
    summaryLine: 'Tag written answers',
    tooltip: {
      title: 'Tag written answers',
      description:
        'Tag written answers to organize them by topic and uncover trends. See the percentage of answers that include each tag.'
    }
  },
  sentiment_analysis: {
    summaryLine: 'Sentiment analysis',
    tooltip: {
      title: 'Sentiment analysis',
      description:
        "We'll automatically label your text responses as positive, neutral, or negative to reveal the emotion behind what people are saying."
    }
  },
  dashboard: {
    summaryLine: 'Dashboard',
    tooltip: {
      title: 'Dashboard',
      description:
        'Tell stories with your data by arranging charts, images, and findings in a custom layout. Share your dashboard with anyone.'
    }
  },
  dashboard_password_protection: {
    summaryLine: 'Dashboard: Password protection',
    tooltip: {
      title: 'Dashboard: Password protection',
      description: 'Set a password for your dashboards for share more securely.'
    }
  },
  statistical_significance: {
    summaryLine: 'Statistical significance',
    tooltip: {
      title: 'Statistical significance',
      description:
        'Use to see if there are statistically significant differences between response groups.'
    }
  },
  benchmarks: {
    summaryLine: 'SurveyMonkey Global Benchmarks',
    tooltip: {
      title: 'SurveyMonkey Global Benchmarks',
      description:
        'SurveyMonkey Global Benchmarks give your results context by letting you compare them with the global average. More specific comparison data is available for an extra fee.'
    }
  },
  validate_answer: {
    summaryLine: 'Answer validation',
    tooltip: {
      title: 'Answer validation',
      description:
        'Require the text in survey responses to meet formatting and content criteria you set.'
    }
  },
  randomize_answer_choices: {
    summaryLine: 'Randomize answer choices',
    tooltip: {
      title: 'Randomize answer choices',
      description:
        'Reduce bias by randomly changing the order of answer choices for different respondents.'
    }
  },
  view_respondent_ip_address: {
    summaryLine: "View respondent's IP address",
    tooltip: {
      title: "View respondent's IP address",
      description:
        'Automatically record the IP address of respondents to get a better sense of who answers your surveys.'
    }
  },
  record_respondent_email_address: {
    summaryLine: 'Record respondent email address',
    tooltip: {
      title: 'Record respondent email address',
      description:
        'Automatically record the email address of respondents to track who takes your surveys, or to follow up with them later.'
    }
  },
  confirmation_email_to_respondents: {
    summaryLine: 'Confirmation Email to Respondents',
    tooltip: {
      title: 'Confirmation Email to Respondents',
      description:
        'When distributing surveys with the email collector, send a confirmation email to each respondent with a copy of their answers.'
    }
  },
  complimentary_audience_credits: {
    summaryLine: 'Audience panel credits',
    tooltip: {
      title: 'Audience panel credits',
      description:
        'Send surveys to your target market with SurveyMonkey Audience, our market research panel with millions of people worldwide. You can choose from 100+ attributes to conduct market research quickly and effectively. Audience can also be purchased separately.'
    }
  },
  hipaa_enabled: {
    summaryLine: 'HIPAA-compliant features',
    tooltip: {
      title: 'HIPAA-compliant features',
      description:
        'Safeguard protected health information with HIPAA-compliant features and a Business Associate Agreement.'
    }
  },
  send_surveys: {
    summaryLine: 'Send surveys',
    tooltip: {
      title: 'Send surveys',
      description:
        'Seamlessly send surveys using powerful 3rd-party integration tools.'
    }
  },
  mobile_sdk: {
    summaryLine: 'Mobile SDK',
    tooltip: {
      title: 'Mobile SDK',
      description:
        'Integrate surveys directly into your iOS and Android mobile app.'
    }
  },
  mobile_sdk_data_pull: {
    summaryLine: 'Mobile SDK - Data Pull',
    tooltip: {
      title: 'Mobile SDK - Data Pull',
      description:
        'Take actions in your app based on survey responses collected through the Mobile SDK. For example, prompt people to leave a review if they enter a positive rating.'
    }
  },
  extract_data: {
    summaryLine: 'Extract data',
    tooltip: {
      title: 'Extract data',
      description:
        'Extract and leverage your survey data using powerful 3rd-party integration tools.'
    }
  },
  api_access: {
    summaryLine: 'Get direct API access',
    tooltip: {
      title: 'Get direct API access',
      description:
        'Create your own application to send surveys and extract your survey data.'
    }
  },
  multilingual: {
    summaryLine: 'Multilingual surveys',
    tooltip: {
      title: 'Multilingual surveys',
      description:
        "Reach everyone in the language they're most comfortable with. Add multiple languages to a single survey, and analyze all your results together as one data set."
    }
  },
  quizzes_pro: {
    summaryLine: 'Quizzes Pro',
    tooltip: {
      title: 'Quizzes Pro',
      description:
        'Show custom feedback for correct, partially correct, and incorrect responses as people take your quiz. At the end, show people custom feedback based on their overall score. Quizzes Pro also lets you email people their quiz results automatically, or export your quiz statistics in PDF, XLS, and CSV format.'
    }
  },
  recurring_surveys: {
    summaryLine: 'Recurring surveys',
    tooltip: {
      title: 'Recurring surveys',
      description:
        "Recurring surveys make it easy to collect new results for the same survey on a weekly, monthly, or quarterly basis. We'll email you new survey links when they're ready, so all you need to do is copy each new link and send it to respondents. Filter your results by each occurrence to see how people responded differently over time."
    }
  },
  industry_benchmarks: {
    summaryLine: 'SurveyMonkey Industry Benchmarks',
    tooltip: {
      title: 'SurveyMonkey Industry Benchmarks',
      description:
        "Compare your results against the Industry Benchmark to understand how you're doing in the context of your greater industry. See your results in context to see how you measure up against your peers."
    }
  },
  custom_question_bank: {
    summaryLine: 'Custom Question Bank',
    tooltip: {
      title: 'Custom Question Bank',
      description:
        'Easily create pre-composed survey questions that are unique to your business, and to share them with your entire organization.'
    }
  },
  payment_question_type: {
    summaryLine: 'Accept Payments',
    tooltip: {
      title: 'Accept Payments',
      description:
        'Accept credit card payments from respondents in your surveys with our Stripe integration.'
    }
  },
  inactivity_timer: {
    summaryLine: 'Kiosk Mode: Inactivity Timer',
    tooltip: {
      title: 'Kiosk Mode: Inactivity Timer',
      description:
        "When a survey's inactive for the amount of time you choose, it will loop back to start for the next person. Available in the SurveyMonkey Anywhere app."
    }
  },
  passcode_lock: {
    summaryLine: 'Kiosk Mode: Passcode Lock',
    tooltip: {
      title: 'Kiosk Mode: Passcode Lock',
      description:
        'Keep your device secure-set a passcode that must be entered to exit the survey. Available in the SurveyMonkey Anywhere app.'
    }
  },
  premium_themes: {
    summaryLine: 'Premium themes',
    tooltip: {
      title: 'Premium themes',
      description:
        'Select from pre-designed themes to pick a survey theme that matches the topic of your survey. You can also edit the premium themes to create a fully customized design using colors, fonts, images and layouts.'
    }
  },
  custom_subdomain: {
    summaryLine: 'Custom subdomain',
    tooltip: {
      title: 'Custom subdomain',
      description:
        'Get a custom URL and landing page to ensure a seamlessly branded survey experience for your respondents.'
    }
  },
  team_customer_success_manager: {
    summaryLine: 'Customer Success Manager',
    tooltip: {
      title: 'Customer Success Manager',
      description:
        'Get a dedicated customer success manager to help you with onboarding, training users as well as implementing best practices to ensure optimal use of the SurveyMonkey platform across your organization.'
    }
  },
  enterprise_admin_dashboard: {
    summaryLine: 'Admin dashboard',
    tooltip: {
      title: 'Admin dashboard',
      description:
        "Get visibility into your team's activity. View usage metrics like the number of surveys each user has in their account, and the date of their last login. You can also preview surveys in each account too."
    }
  },
  enterprise_activity_tracking: {
    summaryLine: 'Team activity',
    tooltip: {
      title: 'Team activity',
      description:
        'Track all user activity in your Enterprise account, such as user logins, survey creation, survey sharing, survey exports, etc. with the ability to search and filter through audit logs.'
    }
  },
  enterprise_account_control: {
    summaryLine: 'Account control',
    tooltip: {
      title: 'Account control',
      description:
        "Automate onboarding users. Seamlessly enable new users to sign up or migrate existing users into your organization's SurveyMonkey Enterprise account."
    }
  },
  enterprise_sso: {
    summaryLine: 'Single sign-on',
    tooltip: {
      title: 'Single sign-on',
      description:
        'Control access to SurveyMonkey across the organization and define authentication policies for increased security and governance.'
    }
  },
  enterprise_global_settings: {
    summaryLine: 'Global settings',
    tooltip: {
      title: 'Global settings',
      description:
        'Create global settings for everyone in your plan. Includes PII management, collector and respondent data settings, and Audience credits management.'
    }
  },
  enterprise_custom_terms_of_service: {
    summaryLine: 'Custom Terms of Use',
    tooltip: {
      title: 'Custom Terms of Use',
      description:
        "Ensure your employees opt in to your organization's Terms of Use for SurveyMonkey."
    }
  },
  enterprise_integrations: {
    summaryLine: 'Enterprise-only integrations',
    tooltip: {
      title: 'Enterprise-only integrations',
      description:
        'Enterprise plans enjoy unlimited API access and can add on integrations with Salesforce, Marketo, Eloqua, Tableau, and more.'
    }
  },
  enterprise_hipaa_compliance: {
    summaryLine: 'HIPAA-compliant features',
    tooltip: {
      title: 'HIPAA-compliant features',
      description:
        'Collect and manage Protected Health Information (PHI) through surveys. To enable HIPAA features, you must enter into a Business Associate Agreement (BAA) with SurveyMonkey.'
    }
  },
  summary_accept_payments: {
    summaryLine: 'Accept payments',
    tooltip: {
      title: 'Accept payments',
      description:
        'Add a payment page to the end of your survey and accept payments through Stripe. Respondents can complete a survey and make a credit card payment at one time and in one place.'
    }
  },
  summary_24_7_customer_support_via_email: {
    summaryLine: '24/7 customer support via email',
    tooltip: {
      title: '24/7 customer support via email',
      description:
        'We offer 24/7 email support for all customers. Emails from {gold_equivalent_name} and {platinum_equivalent_name} customers are prioritized to receive responses as quickly as possible. We also offer phone support for our {platinum_equivalent_name} customers.'
    }
  },
  summary_24_7_customer_support_via_email_intl: {
    summaryLine: '24/7 customer support via email',
    tooltip: {
      title: '24/7 customer support via email',
      description:
        'We offer 24/7 email support for all customers. Emails from {gold_equivalent_name} and {platinum_equivalent_name} customers are prioritized to receive responses as quickly as possible.'
    }
  },
  summary_team_accounts_and_tools: {
    summaryLine: "<span class='new'>NEW!</span> Team accounts &amp; tools",
    tooltip: {
      title: "<span class='new'>NEW!</span> Team accounts &amp; tools",
      description:
        'Our {gold_equivalent_name} and {platinum_equivalent_name} plans include 2 user accounts, which allow you and another person to enjoy our team collaboration tools. These tools help you create, edit, and analyze surveys easily and safely with another person. Each user will have their own unique sign-in credentials. The accounts can securely share surveys and data, and you can also choose to keep some surveys or data private and only available to you.'
    }
  },
  summary_team_collaboration_available: {
    summaryLine: 'Team collaboration available',
    tooltip: {
      title: 'Team collaboration available',
      description:
        'You can convert your existing account into a team account. This allows you to create, edit, and analyze surveys with others and access a shared library of images, documents, themes, and templates. You can invite people to your team for an additional fee.'
    }
  },
  summary_advanced_data_exports: {
    summaryLine: 'Advanced data exports',
    tooltip: {
      title: 'Advanced data exports',
      description:
        'Download your survey results into SPSS-along with CSV, PDF, PPT, or XLS files too. Also create and print custom charts and reports quickly and easily.'
    }
  },
  summary_sentiment_analysis: {
    summaryLine: 'SENTIMENT ANALYSIS',
    tooltip: {
      title: 'SENTIMENT ANALYSIS',
      description:
        "We'll automatically label your text responses as positive, neutral, or negative to reveal the emotion behind what people are saying."
    }
  },
  summary_survey_logic: {
    summaryLine: 'Survey logic',
    tooltip: {
      title: 'Survey logic',
      description:
        'Create smart surveys. Reduce answer bias by randomizing pages or questions on a specific page. Conduct A/B tests and test for answer bias by randomly segmenting respondents to see different images or text. Plus, close your survey automatically when you get all the qualified responses you need.'
    }
  },
  summary_survey_analysis: {
    summaryLine: 'Survey analysis',
    tooltip: {
      title: 'Survey analysis',
      description:
        'Get more insights from your survey results. Trended data makes it easy to spot changes when they happen by allowing you to view your results trended over time. Use filters and crosstabs to segment your respondents and discover hidden trends. With a {basic_equivalent_name} plan, you can apply and save one filter rule to your data, but paid plans allow you to save and apply an unlimited number of filter rules.'
    }
  },
  summary_advanced_survey_analysis_asia: {
    summaryLine: 'Advanced survey analysis',
    tooltip: {
      title: 'Advanced survey analysis',
      description:
        'Get more context for your data. See if there are statistically significant differences between response groups.'
    }
  },
  summary_audience_panel_credits: {
    summaryLine: 'Audience panel credits',
    tooltip: {
      title: 'Audience panel credits',
      description:
        'Use SurveyMonkey Audience to easily run your own market research. Our market research panel includes millions of people worldwide. Choose from several demographic attributes to send surveys to your target market.'
    }
  },
  summary_team_share_surveys: {
    summaryLine: 'BUILD SURVEYS TOGETHER',
    tooltip: {
      title: 'BUILD SURVEYS TOGETHER',
      description:
        'Let people on your team view, edit, or comment on your surveys.'
    }
  },
  summary_team_comments: {
    summaryLine: 'COMMENTING FEATURE',
    tooltip: {
      title: 'COMMENTING FEATURE',
      description:
        'Invite people to provide feedback on your survey projects all ine one place. Our commenting feature allows you to share both survey drafts or results with anyone you want.'
    }
  },
  summary_team_analyze_filter_export: {
    summaryLine: 'ANALYZE RESULTS TOGETHER',
    tooltip: {
      title: 'ANALYZE RESULTS TOGETHER',
      description: 'Give your team access to survey results and export tools.'
    }
  },
  summary_team_responses_nodification: {
    summaryLine: 'RESPONSE ALERTS',
    tooltip: {
      title: 'RESPONSE ALERTS',
      description:
        "Receive email notifications about new survey responses. You can share Response Alerts with other people (in or outside your team)-as long as you're the survey owner."
    }
  },
  summary_team_shared_library: {
    summaryLine: 'SHARED LIBRARY',
    tooltip: {
      title: 'SHARED LIBRARY',
      description:
        'Get access to shared images, documents, themes, and templates that everyone in your team can use.'
    }
  },
  summary_team_add_reassign_accounts: {
    summaryLine: 'TEAM MANAGEMENT',
    tooltip: {
      title: 'TEAM MANAGEMENT',
      description:
        "If you're the Primary Admin or Admin of a team, you can invite more people to join the team and manage existing accounts."
    }
  },
  summary_team_collaboration_app_integrations: {
    summaryLine: 'INTEGRATIONS',
    tooltip: {
      title: 'INTEGRATIONS',
      description:
        "SurveyMonkey integrates with popular apps like Office 365, Google Drive, and Slack, so it's easy to use with your existing workflows."
    }
  },
  summary_team_surveys_questions_responses: {
    summaryLine: 'NUMBER OF SURVEYS',
    tooltip: {
      title: 'NUMBER OF SURVEYS',
      description:
        'You can create and send as many surveys, polls, and quizzes as you need.'
    }
  },
  summary_team_expedited_email_support: {
    summaryLine: '24/7 CUSTOMER SUPPORT VIA EMAIL',
    tooltip: {
      title: '24/7 CUSTOMER SUPPORT VIA EMAIL',
      description:
        'We offer 24/7 email support for all customers. Emails from TEAM ADVANTAGE and TEAM PREMIER customers are prioritized to receive responses as quickly as possible. We also offer phone support for our TEAM PREMIER customers.'
    }
  },
  summary_team_quizzes: {
    summaryLine: 'QUIZZES',
    tooltip: {
      title: 'QUIZZES',
      description:
        "Easily create tests and assessments with automatic scoring for employees, customers, students, and more. You can choose whether you want to display your respondent's score to them after they complete your quiz. You'll also be able to see rankings, segment response data, and access statistics for your results."
    }
  },
  summary_team_filters_and_crosstabs: {
    summaryLine: 'FILTER AND COMPARE RULES',
    tooltip: {
      title: 'FILTER AND COMPARE RULES',
      description:
        'Use filter and compare rules to segment your data and discover hidden trends. With a Basic plan, you can apply and save one rule to your data, but paid plans allow you to save and apply an unlimited number of rules. Data trends let you see how your results have changed over time.'
    }
  },
  summary_team_custom_logo: {
    summaryLine: 'CUSTOMIZED SURVEYS',
    tooltip: {
      title: 'CUSTOMIZED SURVEYS',
      description:
        "Customize your survey's look and feel by adding your logo, selecting colors and web fonts, and uploading images. Create and save custom themes to quickly build on-brand surveys. You can also modify the ending of your survey's URL. For example: www.surveymonkey.com/s/your-survey"
    }
  },
  summary_team_skip_logic: {
    summaryLine: 'CUSTOMIZED SURVEY EXPERIENCE',
    tooltip: {
      title: 'CUSTOMIZED SURVEY EXPERIENCE',
      description:
        "Get more ways to personalize each respondent's experience while taking your survey. Use skip logic to create custom paths through a survey based on each respondent's answers. With question & answer piping, you can insert answer text from a question into another question on a later page in the survey."
    }
  },
  summary_team_data_exports: {
    summaryLine: 'DATA EXPORTS',
    tooltip: {
      title: 'DATA EXPORTS',
      description:
        "Create and print custom charts and reports quickly and easily. You'll be able to download survey results in several file formats, including as CSV, PDF, PPT, or XLS files. Export for SPSS for Advantage and Premier members."
    }
  },
  summary_team_advanced_analyze: {
    summaryLine: 'ADVANCED SURVEY ANALYSIS',
    tooltip: {
      title: 'ADVANCED SURVEY ANALYSIS',
      description:
        'Get more context for your data. See if there are statistically significant differences between response groups. And use text analysis to search and categorize open-ended responses and quickly see frequently used words and phrases.'
    }
  },
  summary_team_industry_benchmarks: {
    summaryLine: 'SURVEYMONKEY INDUSTRY BENCHMARKS',
    tooltip: {
      title: 'SURVEYMONKEY INDUSTRY BENCHMARKS',
      description:
        "Compare your results against the Industry Benchmark to understand how you're doing in the context of your greater industry. See your results in context to see how you measure up against your peers."
    }
  },
  summary_team_advanced_survey_logic: {
    summaryLine: 'ADVANCED SURVEY LOGIC',
    tooltip: {
      title: 'ADVANCED SURVEY LOGIC',
      description:
        'Enhance your survey data with access to advanced branching, advanced piping, block randomization, quotas, and more. Use custom variables to track data about respondents by passing one or more values through a survey link and into your survey results.'
    }
  },
  summary_team_block_randomization: {
    summaryLine: 'BLOCK RANDOMIZATION',
    tooltip: {
      title: 'BLOCK RANDOMIZATION',
      description:
        'Blocks are groups of pages, where each group contains related questions about a particular concept you want to test. You can use block randomization logic to rotate, flip, or randomize blocks to minimize order bias.'
    }
  },
  summary_team_white_label: {
    summaryLine: 'WHITE LABEL SURVEYS',
    tooltip: {
      title: 'WHITE LABEL SURVEYS',
      description:
        'Completely customize and brand your surveys. Remove the SurveyMonkey footer from your surveys, change the domain of your survey link to research.net, and redirect survey respondents to your site upon survey completion.'
    }
  },
  summary_team_multilingual: {
    summaryLine: 'MULTILINGUAL SURVEYS',
    tooltip: {
      title: 'MULTILINGUAL SURVEYS',
      description:
        "Reach everyone in the language they're most comfortable with. Add multiple languages to a single survey, and analyze all your results together as one data set."
    }
  },
  summary_team_completion_redirect: {
    summaryLine: 'SURVEY COMPLETION REDIRECT',
    tooltip: {
      title: 'SURVEY COMPLETION REDIRECT',
      description:
        'For a customized experience, redirect survey respondents to your website once they complete your survey.'
    }
  },
  summary_team_remove_surveymonkey_footer: {
    summaryLine: 'REMOVE FOOTER',
    tooltip: {
      title: 'REMOVE FOOTER',
      description:
        'Turn off the "powered by SurveyMonkey" footer that appears by default in your survey design, email invitation messages, and embedded surveys.'
    }
  },
  summary_team_api_access: {
    summaryLine: 'GET DIRECT API ACCESS',
    tooltip: {
      title: 'GET DIRECT API ACCESS',
      description:
        'Create your own application to send surveys and extract your survey data.'
    }
  },
  summary_team_role_based_collaboration: {
    summaryLine: 'COLLABORATION AT SCALE',
    tooltip: {
      title: 'COLLABORATION AT SCALE',
      description:
        'Organize teams with a shared purpose into workgroups to collaborate on survey projects. Easily share surveys with everyone in a workgroup and assign roles and permissions to ensure users have the right level of access to survey data.'
    }
  },
  summary_team_flexible_plan_types: {
    summaryLine: 'FLEXIBLE PLAN TYPES',
    tooltip: {
      title: 'FLEXIBLE PLAN TYPES',
      description:
        "Enjoy flexible and custom plan types to fit your organization's survey needs. "
    }
  },
  summary_team_hipaa_compliant: {
    summaryLine: 'HIPAA-COMPLIANT FEATURES',
    tooltip: {
      title: 'HIPAA-COMPLIANT FEATURES',
      description:
        'Collect and manage Protected Health Information (PHI) through surveys. To enable HIPAA features, you must enter into a Business Associate Agreement (BAA) with SurveyMonkey.'
    }
  },
  summary_team_custom_branding: {
    summaryLine: 'CUSTOMIZATION AND BRANDING',
    tooltip: {
      title: 'CUSTOMIZATION AND BRANDING',
      description:
        'Ensure a consistent brand experience for all survey-takers and enjoy customization features like Custom Subdomain, Custom Terms of Use and Custom Question Bank.'
    }
  },
  summary_team_3rd_part_integrations: {
    summaryLine: 'INTEGRATIONS',
    tooltip: {
      title: 'INTEGRATIONS',
      description:
        'Integrate your survey data into important business applications that your organization already uses such as Salesforce, Marketo, Oracle Eloqua, and Tableau.'
    }
  },
  summary_team_unlimited_api_access: {
    summaryLine: 'UNLIMITED API ACCESS',
    tooltip: {
      title: 'UNLIMITED API ACCESS',
      description:
        'Get unlimited access to the SurveyMonkey API to integrate survey data into your mobile and web applications.'
    }
  },
  summary_team_admin_dashboard: {
    summaryLine: 'ADMIN DASHBOARD',
    tooltip: {
      title: 'ADMIN DASHBOARD',
      description:
        "Get visibility into your team's activity. View usage metrics like the number of surveys each user has in their account, and the date of their last login. You can also preview surveys in each account too."
    }
  },
  summary_team_account_control_migration: {
    summaryLine: 'ACCOUNT CONTROL',
    tooltip: {
      title: 'ACCOUNT CONTROL',
      description:
        "Automate onboarding users. Seamlessly enable new users to sign up or migrate existing users into your organization's SurveyMonkey Enterprise account."
    }
  },
  summary_team_enhanced_governance_security: {
    summaryLine: 'GOVERNANCE AND SECURITY',
    tooltip: {
      title: 'GOVERNANCE AND SECURITY',
      description:
        'Get access to a vast array of governance and security features, including SSO for user authentication, data encryption, access controls, SSAE-16 SOC II compliant data centers and more.'
    }
  },
  summary_team_sso: {
    summaryLine: 'SINGLE SIGN-ON',
    tooltip: {
      title: 'SINGLE SIGN-ON',
      description:
        'Control access to SurveyMonkey across the organization and define authentication policies for increased security and governance.'
    }
  },
  summary_team_logs_audit: {
    summaryLine: 'TEAM ACTIVITY',
    tooltip: {
      title: 'TEAM ACTIVITY',
      description:
        'Track all user activity in your Enterprise account, such as user logins, survey creation, survey sharing, survey exports, etc. with the ability to search and filter through audit logs.'
    }
  },
  summary_team_customer_success_manager: {
    summaryLine: 'CUSTOMER SUCCESS',
    tooltip: {
      title: 'CUSTOMER SUCCESS',
      description:
        'Get a dedicated customer success manager to help you with onboarding, training users as well as implementing best practices to ensure optimal use of the SurveyMonkey platform across your organization.'
    }
  },
  summary_team_priority_247_email_phone_support: {
    summaryLine: 'PRIORITY SUPPORT',
    tooltip: {
      title: 'PRIORITY SUPPORT',
      description:
        'We offer 24/7 email support for all customers. Emails from Enterprise customers are prioritized to receive responses as quickly as possible. We also offer English-only phone support.'
    }
  },
  summary_number_of_surveys: {
    summaryLine: 'Number of surveys',
    tooltip: {
      title: 'Number of surveys',
      description:
        'You can create and send as many surveys, polls, and quizzes as you need with any plan.'
    }
  },
  summary_questions_per_survey: {
    summaryLine: 'Questions per survey',
    tooltip: {
      title: 'Questions per survey',
      description:
        'Some of our plans only allow a certain number of questions for each survey you send. All plans allow you to create and send as many surveys as you want.'
    }
  },
  summary_number_of_responses: {
    summaryLine: 'Number of responses',
    tooltip: {
      title: 'Number of responses',
      description:
        "With a free plan, you can collect more than 100 responses, but you can only view the first 100 responses. Upgrade at any time to access additional responses. Our {select_equivalent_name} Monthly plan includes 1000 responses per monthly billing cycle across all your surveys with a <span class='notranslate'>{overage_cost}</span> charge per additional response. All annual plans include an unlimited number of responses."
    }
  },
  summary_number_of_responses_monthly_plans: {
    summaryLine: 'Number of responses',
    tooltip: {
      title: 'Number of responses',
      description:
        "With a free plan, you can collect more than 100 responses, but you can only view the first 100 responses. Upgrade at any time to access additional responses. Our {select_equivalent_name} Monthly plan includes 1,000 responses and our {gold_equivalent_name} Monthly plan includes 2,000 responses per monthly billing cycle across all your surveys. There is a <span class='notranslate'>{overage_cost}</span> charge per additional response. All annual plans include unlimited responses."
    }
  },
  summary_customer_support: {
    summaryLine: '24/7 customer support via email',
    tooltip: {
      title: '24/7 customer support via email',
      description:
        'We offer 24/7 email support for all customers. Emails from {gold_equivalent_name} and {platinum_equivalent_name} customers are prioritized to receive responses as quickly as possible. We also offer phone support for our {platinum_equivalent_name} customers.'
    }
  },
  summary_customer_support_monthly_plans: {
    summaryLine: '24/7 customer support via email',
    tooltip: {
      title: '24/7 customer support via email',
      description:
        'We offer 24/7 email support for all customers. Emails from {gold_equivalent_name} and {platinum_equivalent_name} customers are prioritized to receive responses as quickly as possible. We also offer phone support for our {platinum_equivalent_name} Annual customers.'
    }
  },
  summary_english_customer_support: {
    summaryLine: '24/7 English email support',
    tooltip: {
      title: '24/7 English email support',
      description:
        'We offer 24/7 email support for all customers. Emails from {gold_equivalent_name} and {platinum_equivalent_name} customers are prioritized to receive responses as quickly as possible. We also offer phone support for our {platinum_equivalent_name} customers.'
    }
  },
  summary_international_customer_support: {
    summaryLine: '{lang} email support',
    tooltip: {
      title: '{lang} email support',
      description:
        'We offer {lang} email support in Central European Time (CET).'
    }
  },
  summary_user_accounts: {
    summaryLine: 'User accounts included',
    tooltip: {
      title: 'User accounts included',
      description:
        'This is the total number of user accounts included with your plan. Plans with more than 1 user have access to all team collaboration tools. '
    }
  },
  summary_quizzes: {
    summaryLine: "<span class='new'>NEW!</span> Quizzes",
    tooltip: {
      title: "<span class='new'>NEW!</span> Quizzes",
      description:
        "Easily create tests and assessments with automatic scoring for employees, customers, students, and more. You can choose whether you want to display your respondent's score to them after they complete your quiz. You'll also be able to see rankings, segment response data, and access statistics for your results."
    }
  },
  summary_filters_and_crosstabs: {
    summaryLine: 'FILTER AND COMPARE RULES',
    tooltip: {
      title: 'FILTER AND COMPARE RULES',
      description:
        'Use filter and compare rules to segment your data and discover hidden trends. With a Basic plan, you can apply and save one rule to your data, but paid plans allow you to save and apply an unlimited number of rules. Data trends let you see how your results have changed over time.'
    }
  },
  summary_trended_data: {
    summaryLine: 'Trended Data',
    tooltip: {
      title: 'Trended Data',
      description:
        'Get more insights from your survey results. Trended data makes it easy to spot changes when they happen by allowing you to view your results trended over time.'
    }
  },
  summary_customized_surveys: {
    summaryLine: 'Customized surveys',
    tooltip: {
      title: 'Customized surveys',
      description:
        "Customize your survey's look and feel by adding your logo, selecting colors and web fonts, and uploading images. Create and save custom themes to quickly build on-brand surveys. You can also modify the ending of your survey's URL. For example: www.surveymonkey.com/s/your-survey"
    }
  },
  summary_data_exports: {
    summaryLine: 'Data exports',
    tooltip: {
      title: 'Data exports',
      description:
        "Create and print custom charts and reports quickly and easily. You'll be able to download survey results in several file formats, including as CSV, PDF, PPT, or XLS files. Export for SPSS for Advantage and Premier members."
    }
  },
  summary_customized_survey_experience: {
    summaryLine: 'Customized survey experience',
    tooltip: {
      title: 'Customized survey experience',
      description:
        "Get more ways to personalize each respondent's experience while taking your survey. Use skip logic to create custom paths through a survey based on each respondent's answers. With question & answer piping, you can insert answer text from a question into another question on a later page in the survey."
    }
  },
  summary_a_b_testing: {
    summaryLine: 'A/B test question type',
    tooltip: {
      title: 'A/B test question type',
      description:
        'Conduct A/B tests and test for answer bias by randomly segmenting respondents to see different images or text.'
    }
  },
  summary_ab_testing: {
    summaryLine: 'A/B testing, randomization, quotas',
    tooltip: {
      title: 'A/B testing, randomization, quotas',
      description:
        'Conduct A/B tests and test for answer bias by randomly segmenting respondents to see different images or text.'
    }
  },
  summary_block_randomization: {
    summaryLine: 'Block randomization',
    tooltip: {
      title: 'Block randomization',
      description:
        'Blocks are groups of pages, where each group contains related questions about a particular concept you want to test. You can use block randomization logic to rotate, flip, or randomize blocks to minimize order bias.'
    }
  },
  summary_quotas: {
    summaryLine: 'Response quotas',
    tooltip: {
      title: 'Response quotas',
      description:
        'Close your survey automatically when you get all the qualified responses you need.'
    }
  },
  summary_custom_variables: {
    summaryLine: 'Custom variables',
    tooltip: {
      title: 'Custom variables',
      description:
        'Use custom variables to track data about respondents by passing one or more values through a survey link and into your survey results.'
    }
  },
  summary_file_upload: {
    summaryLine: 'File upload',
    tooltip: {
      title: 'File upload',
      description:
        'Allow respondents to upload a file as part of their survey response. You can add up to 20 file upload questions per survey.'
    }
  },
  summary_statistical_significance: {
    summaryLine: 'Statistical significance',
    tooltip: {
      title: 'Statistical significance',
      description:
        'Use to see if there are statistically significant differences between response groups.'
    }
  },
  summary_complimentary_audience_credits: {
    summaryLine: 'Audience panel credits',
    tooltip: {
      title: 'Audience panel credits',
      description:
        'Use SurveyMonkey Audience to easily run your own market research. Our market research panel includes millions of people worldwide. Choose from several demographic attributes to send surveys to your target market.'
    }
  },
  summary_industry_benchmarks: {
    summaryLine: 'SurveyMonkey Industry Benchmarks',
    tooltip: {
      title: 'SurveyMonkey Industry Benchmarks',
      description:
        "Compare your results against the Industry Benchmark to understand how you're doing in the context of your greater industry. See your results in context to see how you measure up against your peers."
    }
  },
  summary_advanced_logic: {
    summaryLine: 'Advanced survey logic',
    tooltip: {
      title: 'Advanced survey logic',
      description:
        'Enhance your survey data with access to advanced branching, advanced piping, block randomization, quotas, and more. Use custom variables to track data about respondents by passing one or more values through a survey link and into your survey results.'
    }
  },
  summary_collector_white_label_enabled: {
    summaryLine: 'White label surveys',
    tooltip: {
      title: 'White label surveys',
      description:
        'Completely customize and brand your surveys. Remove the SurveyMonkey footer from your surveys, change the domain of your survey link to research.net, and redirect survey respondents to your site upon survey completion.'
    }
  },
  summary_multilingual: {
    summaryLine: 'Multilingual surveys',
    tooltip: {
      title: 'Multilingual surveys',
      description:
        "Reach everyone in the language they're most comfortable with. Add multiple languages to a single survey, and analyze all your results together as one data set."
    }
  },
  summary_text_analysis: {
    summaryLine: 'Text analysis',
    tooltip: {
      title: 'Text analysis',
      description:
        'Use to see if there are statistically significant differences between response groups.'
    }
  },
  summary_advanced_survey_analysis: {
    summaryLine: 'Advanced survey analysis',
    tooltip: {
      title: 'Advanced survey analysis',
      description:
        'Get more context for your data. See if there are statistically significant differences between response groups. And use text analysis to search and categorize open-ended responses and quickly see frequently used words and phrases.'
    }
  },
  summary_randomize_question_page_blocks: {
    summaryLine: 'Randomization',
    tooltip: {
      title: 'Randomization',
      description:
        'Create smart surveys. Reduce answer bias by randomizing pages or questions on a specific page.'
    }
  },
  summary_piping: {
    summaryLine: 'Question and answer piping',
    tooltip: {
      title: 'Question and answer piping',
      description:
        'With question & answer piping, you can insert answer text from a question into another question on a later page in the survey.'
    }
  },
  summary_redirect: {
    summaryLine: 'Redirect respondents to your website',
    tooltip: {
      title: 'Redirect respondents to your website',
      description:
        'Redirect respondents to your own webpage upon survey completion. Enter the URL to a website of your choice.'
    }
  },
  summary_phone_support: {
    summaryLine: 'Phone support',
    tooltip: {
      title: 'Phone support',
      description:
        'PREMIER customers enjoy the quickest replies in addition to phone support (English only).'
    }
  },
  summary_carry_forward: {
    summaryLine: 'Carry forward responses',
    tooltip: {
      title: 'Carry forward responses',
      description:
        "Use each respondent's previous answer choices in a related question that appears later in your survey. You can carry forward either a respondent's selected or unselected answer choices and choose to show all or some previously selected or unselected answers. Responses that are carried forward cannot be edited."
    }
  },
  summary_matrix_of_dropdown_menus: {
    summaryLine: 'Matrix of dropdown menus',
    tooltip: {
      title: 'Matrix of dropdown menus',
      description:
        'Allow respondents to evaluate several items using the same set of measurements by choosing from a preset list of answer choices.'
    }
  },
  summary_advanced_branching_and_piping: {
    summaryLine: 'Advanced branching and piping',
    tooltip: {
      title: 'Advanced branching and piping',
      description:
        "Personalize the survey experience using advanced branching and piping logic. Build conditions and insert text based on your respondent's answers, custom data from contacts, and custom variables. Skip respondents to future points in your survey, show or hide questions, show or hide pages, or invalidate questions and customize the error message."
    }
  },
  summary_advanced_data_exports_spss: {
    summaryLine: 'Advanced data exports (SPSS)',
    tooltip: {
      title: 'Advanced data exports (SPSS)',
      description:
        'Download your survey results into SPSS-along with CSV, PDF, PPT, or XLS files too. Also create and print custom charts and reports quickly and easily.'
    }
  },
  summary_abbr_customized_surveys: {
    summaryLine: 'Custom logo, colors & fonts, survey link',
    tooltip: {
      title: 'Custom logo, colors & fonts, survey link',
      description:
        "Customize your survey's look and feel by adding your logo, selecting colors and web fonts, and uploading images. Create and save custom themes to quickly build on-brand surveys. You can also modify the ending of your survey's URL. For example: www.surveymonkey.com/s/your-survey"
    }
  },
  summary_abbr_data_exports: {
    summaryLine: 'Data exports',
    tooltip: {
      title: 'Data exports',
      description:
        'Download your data as a spreadsheet, or friendly formats like PDF or PowerPoint.'
    }
  },
  summary_abbr_unlimited_data_filters: {
    summaryLine: 'Unlimited data filters',
    tooltip: {
      title: 'Unlimited data filters',
      description: 'Drill down into segments of your data and save each view.'
    }
  },
  summary_abbr_compare_crosstabs: {
    summaryLine: 'Compare results with crosstabs',
    tooltip: {
      title: 'Compare results with crosstabs',
      description:
        'See side-by-side comparisons of how different groups answered your survey.'
    }
  },
  summary_abbr_skip_logic: {
    summaryLine: 'Skip logic',
    tooltip: {
      title: 'Skip logic',
      description:
        'Skip people to different places in your survey based on how they answer.'
    }
  },
  summary_abbr_text_analysis: {
    summaryLine: 'Text analysis',
    tooltip: {
      title: 'Text analysis',
      description:
        'Uncover trends in written answers with tagging, word clouds, and sentiment analysis.'
    }
  },
  summary_abbr_statistical_significance: {
    summaryLine: 'Statistical significance',
    tooltip: {
      title: 'Statistical significance',
      description:
        'See if there are statistically significant differences in how different groups answered your survey.'
    }
  },
  summary_abbr_ab_test: {
    summaryLine: 'A/B test question type',
    tooltip: {
      title: 'A/B test question type',
      description:
        'See if variations of an image or text yield different results.'
    }
  },
  summary_abbr_page_question_randomization: {
    summaryLine: 'Question & page randomization',
    tooltip: {
      title: 'Question & page randomization',
      description:
        'Reduce answer bias by randomizing the order of the pages in a survey or the order of questions within a page.'
    }
  },
  summary_abbr_carry_forward: {
    summaryLine: 'Carry forward responses',
    tooltip: {
      title: 'Carry forward responses',
      description:
        "Use each respondent's previous answer choices in a related question that appears later in your survey. You can carry forward either a respondent's selected or unselected answer choices and choose to show all or some previously selected or unselected answers. Responses that are carried forward cannot be edited."
    }
  },
  summary_abbr_file_upload: {
    summaryLine: 'File upload question type',
    tooltip: {
      title: 'File upload question type',
      description:
        'Let people attach image files, PDFs, or documents to their response.'
    }
  },
  summary_abbr_advanced_branching: {
    summaryLine: 'Advanced branching',
    tooltip: {
      title: 'Advanced branching',
      description:
        'Add multi-condition, multi-action rules to build strategic survey experiences.'
    }
  },
  summary_abbr_advanced_piping: {
    summaryLine: 'Advanced question & answer piping',
    tooltip: {
      title: 'Advanced question & answer piping',
      description:
        'Personalize surveys for each person by piping in text from their contact information or custom variables (URL parameters).'
    }
  },
  summary_abbr_custom_redirects: {
    summaryLine: 'Custom survey completion redirects',
    tooltip: {
      title: 'Custom survey completion redirects',
      description:
        'Redirect survey takers to the URL of your choice after they finish your survey.'
    }
  },
  summary_abbr_remove_footer: {
    summaryLine: 'Remove SurveyMonkey branded footer',
    tooltip: {
      title: 'Remove SurveyMonkey branded footer',
      description:
        'Remove the SurveyMonkey footer from your surveys and email invitations.'
    }
  },
  summary_abbr_research_url: {
    summaryLine: 'Anonymous "research.net" URL',
    tooltip: {
      title: 'Anonymous "research.net" URL',
      description:
        'Use research.net for your survey link instead of surveymonkey.com.'
    }
  },
  summary_custom_survey_link: {
    summaryLine: 'Custom survey link',
    tooltip: {
      title: 'Custom survey link',
      description: 'Make your survey link friendly and easy to read.'
    }
  }
};

export default FEATURES;
